module.exports = __webpack_public_path__ + "static/media/full.3e570843.mp4";